import delay from 'lodash/delay'

export default {
  props: {
    alert: {required: true},
    type: {type: String, default: 'text'}
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    variant () {
      return this.alert.variant
    },
    message () {
      return this.alert.message
    },
    icon () {
      switch (this.alert.variant) {
        case 'success': return 'fa-check'
        case 'warning': return 'fa-exclamation-circle'
        case 'danger': return 'fa-times-circle'
        case 'info': return 'fa-info-circle'
      }
    }
  },
  watch: {
    alert (val) {
      if (!val) {
        this.show = false
      } else if (!this.show) {
        this.show = true
        delay(() => {
          this.show = false
          this.$emit('update:alert', false)
        }, 5000) // Close alert after 5 seconds
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/alerts/alert-mixin.js